import { ComponentConfig, WithId, WithPuckProps } from "@measured/puck";
import {
  MediaComponent,
  MediaComponentProps,
} from "@kunduz/feature-landing-pages";
import { defaultComponentSize, defaultComponentSizeFields } from "../../utils";

export interface MediaProps extends MediaComponentProps {}

const Media = (props: WithId<WithPuckProps<MediaProps>>) => {
  const uniqueKey = `${props.id}-${props.wistiaId || props.file || "none"}-${props.mediaComponentId}`;

  return <MediaComponent key={uniqueKey} {...props} />;
};

export const PuckMedia: ComponentConfig<MediaProps> = {
  label: "Media",
  fields: {
    bgImage: {
      type: "text",
      label: "Background Image",
    },
    file: {
      type: "text",
      label: "Video File",
    },
    wistiaId: {
      type: "text",
      label: "Wistia ID",
    },
    mediaComponentId: {
      type: "number",
      label: "Media Component ID",
    },
    name: {
      type: "text",
      label: "Name",
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    bgImage: "",
    file: "https://staging-media.kunduzapp.com/cms/media/beaver-video.mp4",
    wistiaId: "",
    mediaComponentId: 0,
    name: "",
    options: {
      ...defaultComponentSize,
    },
  },
  render: (props) => <Media {...props} />,
};
